import { ChangeEvent, FC } from "react";
import { HintTooltip } from "@brg/ui";
import {
    FieldWrapper,
    FieldLabelRow,
    FieldLabelLeft,
    FieldLabelText,
    HintIcon,
    LangSwitcher,
    LangButton,
    InputBox,
    StyledInput,
    RequiredStar,
} from "../styles";

interface TextInputFieldProps {
    label: string;
    required?: boolean;
    tooltipText?: string;
    value: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    lang?: 'ru' | 'en';
    onLangChange?: (lang: 'ru' | 'en') => void;
    readOnly?: boolean;
    maxLength?: number;
}

const TOOLTIP_STYLE = { maxWidth: '240px', whiteSpace: 'normal' as const };

export const TextInputField: FC<TextInputFieldProps> = ({
    label,
    required,
    tooltipText,
    value,
    onChange,
    placeholder,
    lang,
    onLangChange,
    readOnly,
    maxLength,
}) => {
    return (
        <FieldWrapper>
            <FieldLabelRow>
                <FieldLabelLeft>
                    <FieldLabelText>{label}{required && <RequiredStar>*</RequiredStar>}</FieldLabelText>
                    {tooltipText && (
                        <HintTooltip noArrow activeOnMobile positionY="top" text={tooltipText} onWhiteBg customStyle={TOOLTIP_STYLE}>
                            <HintIcon>?</HintIcon>
                        </HintTooltip>
                    )}
                </FieldLabelLeft>
                {lang && onLangChange && (
                    <LangSwitcher>
                        <LangButton active={lang === 'ru'} onClick={() => onLangChange('ru')}>RU</LangButton>
                        <LangButton active={lang === 'en'} onClick={() => onLangChange('en')}>EN</LangButton>
                    </LangSwitcher>
                )}
            </FieldLabelRow>
            <InputBox>
                <StyledInput
                    value={value}
                    onChange={onChange ?? (() => {})}
                    placeholder={placeholder}
                    readOnly={readOnly}
                    maxLength={maxLength}
                />
            </InputBox>
        </FieldWrapper>
    );
};
import { ChangeEvent, FC } from "react";
import { HintTooltip } from "@brg/ui";
import {
    FieldWrapper,
    FieldLabelRow,
    FieldLabelLeft,
    FieldLabelText,
    HintIcon,
    LangSwitcher,
    LangButton,
    InputBox,
    StyledInput,
    RequiredStar,
} from "../styles";

interface TextInputFieldProps {
    label: string;
    required?: boolean;
    tooltipText?: string;
    value: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    lang?: 'ru' | 'en';
    onLangChange?: (lang: 'ru' | 'en') => void;
    readOnly?: boolean;
    maxLength?: number;
}

const TOOLTIP_STYLE = { maxWidth: '240px', whiteSpace: 'normal' as const };

export const TextInputField: FC<TextInputFieldProps> = ({
    label,
    required,
    tooltipText,
    value,
    onChange,
    placeholder,
    lang,
    onLangChange,
    readOnly,
    maxLength,
}) => {
    return (
        <FieldWrapper>
            <FieldLabelRow>
                <FieldLabelLeft>
                    <FieldLabelText>{label}{required && <RequiredStar>*</RequiredStar>}</FieldLabelText>
                    {tooltipText && (
                        <HintTooltip noArrow activeOnMobile positionY="top" text={tooltipText} onWhiteBg customStyle={TOOLTIP_STYLE}>
                            <HintIcon>?</HintIcon>
                        </HintTooltip>
                    )}
                </FieldLabelLeft>
                {lang && onLangChange && (
                    <LangSwitcher>
                        <LangButton active={lang === 'ru'} onClick={() => onLangChange('ru')}>RU</LangButton>
                        <LangButton active={lang === 'en'} onClick={() => onLangChange('en')}>EN</LangButton>
                    </LangSwitcher>
                )}
            </FieldLabelRow>
            <InputBox>
                <StyledInput
                    value={value}
                    onChange={onChange ?? (() => {})}
                    placeholder={placeholder}
                    readOnly={readOnly}
                    maxLength={maxLength}
                />
            </InputBox>
        </FieldWrapper>
    );
};
